import { RoundType } from "app/game-data/useFetchGameData";
import getSpellingBeeInstructions from "app/instructions/getSpellingBeeInstructions";
import getBuzzInInstructions from "app/instructions/getBuzzInInstructions";
import getSpeedInstructions from "app/instructions/getSpeedInstructions";
import getTedWordInstructions from "app/instructions/getTedWordInstructions";
import getOneChanceInstructions from "app/instructions/getOneChanceInstructions";

export default function getInstructionsForRoundType(
  roundType: RoundType
): React.ReactNode {
  switch (roundType) {
    case RoundType.SPELLING_BEE:
      return getSpellingBeeInstructions();
    case RoundType.BUZZ_IN:
      return getBuzzInInstructions();
    case RoundType.SPEED:
      return getSpeedInstructions();
    case RoundType.TED_WORD:
      return getTedWordInstructions();
    case RoundType.ONE_CHANCE:
      return getOneChanceInstructions();
    default:
      return [];
  }
}
